<template>
  <div class="page-wrap">
    <div class="page-header">
      <h2><span class="breadcrumb-level">系统管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">系统配置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">首页装修</span></h2>
    </div>
    <div class="home-deco-layout">
      <!-- 左侧：操作区 -->
      <div class="left-panel">
        <div class="tabs-header">
          <el-tabs v-model="activeTab" type="card" style="flex:1">
          <el-tab-pane label="金刚区图标" name="icons">
            <template #label>
              <span>金刚区图标</span>
            </template>
            <el-table :data="icons" stripe size="small" v-loading="iconLoading">
              <el-table-column label="图标" width="55">
                <template #default="{ row }">
                  <el-image :src="row.icon_url" style="width:28px;height:28px" fit="contain" />
                </template>
              </el-table-column>
              <el-table-column label="标题" prop="title" min-width="120" />
              <el-table-column label="排序" width="80">
                <template #default="{ row }">
                  <el-input-number v-model="row.sort_order" :min="0" size="small" controls-position="right" @change="updateIconSort(row)" style="width:70px" />
                </template>
              </el-table-column>
              <el-table-column label="状态" width="65">
                <template #default="{ row }">
                  <el-switch v-model="row.status" size="small" @change="updateIconStatus(row)" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template #default="{ row }">
                  <el-button text size="small" @click="showIconDialog(row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="TabBar" name="tabbar">
            <el-form label-width="100px">
              <div v-for="item in tabbar" :key="item.id" class="config-card">
                <div class="config-card-title">{{ item.key }} — {{ item.text }}</div>
                <div class="config-card-fields">
                  <div class="field-group">
                    <span class="field-label">未选中</span>
                    <Upload v-model="item.icon_unselected_url" :max-count="1" :width="80" :height="56" tip="推荐尺寸 宽 81 × 高 81 px" />
                  </div>
                  <div class="field-group">
                    <span class="field-label">选中</span>
                    <Upload v-model="item.icon_selected_url" :max-count="1" :width="80" :height="56" tip="推荐尺寸 宽 81 × 高 81 px" />
                  </div>
                  <div class="field-group">
                    <span class="field-label">文字</span>
                    <el-input v-model="item.text" style="width:120px" size="small" />
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="宠物选择器" name="pets">
            <el-form label-width="80px">
              <div v-for="item in pets" :key="item.id" class="config-card">
                <div class="config-card-title">{{ item.name }}</div>
                <div class="config-card-fields">
                  <div class="field-group">
                    <span class="field-label">图标</span>
                    <Upload v-model="item.icon_url" :max-count="1" tip="推荐尺寸 宽 88 × 高 88 px" />
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="tabs-actions">
          <el-button v-if="activeTab==='tabbar'" type="primary" size="small" :loading="tabbarSaving" @click="saveTabbar">保存TabBar</el-button>
          <el-button v-if="activeTab==='pets'" type="primary" size="small" :loading="petsSaving" @click="savePets">保存宠物选择器</el-button>
        </div>
        </div>
      </div>

      <!-- 右侧：手机预览 -->
      <div class="right-panel">
        <div class="preview-hint">* 手机预览效果仅供布局参考，实际效果请查看小程序</div>
        <div class="phone-wrapper">
          <div class="phone-frame">
            <div class="phone-content">
              <div class="homepage-preview">
                <!-- 导航栏 -->
                <div class="preview-navbar">
                  <span class="nav-title">宠境宠物乐园</span>
                  <div class="nav-icons">
                    <span class="nav-icon">⋯</span>
                    <span class="nav-icon">⚙</span>
                  </div>
                </div>
                <!-- 轮播图（灰色占位，完整矩形） -->
                <div class="preview-banner">
                  <div class="placeholder-content">轮播图</div>
                  <div class="banner-dots">
                    <span class="dot active"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </div>
                </div>
                  <!-- 会员权益引导 banner -->
                  <div class="preview-vip-placeholder">开通会员 享受更多权益 ›</div>
                  <!-- 宠物选择器 -->
                  <div class="preview-pet-selector">
                    <div v-for="p in pets" :key="p.id" class="preview-pet-item">
                      <div class="preview-pet-img">
                        <el-image :src="p.icon_url" fit="contain" v-if="p.icon_url" />
                      </div>
                      <span>{{ p.name }}</span>
                    </div>
                  </div>
                  <!-- 金刚区 -->
                  <div class="preview-icons">
                    <div v-for="icon in visibleIcons" :key="icon.id" class="preview-icon-item">
                      <div class="preview-icon-img">
                        <el-image :src="icon.icon_url" fit="contain" v-if="icon.icon_url" />
                        <span v-else>?</span>
                      </div>
                      <div class="preview-icon-label">{{ icon.title }}</div>
                    </div>
                  </div>
              </div>
            </div>
            <!-- TabBar 预览：双排展示选中/未选中图标 -->
            <div class="preview-tabbar">
              <div class="tabbar-label">TabBar 图标</div>
              <div class="tabbar-row">
                <div v-for="item in tabbar" :key="item.id" class="preview-tab-item">
                  <div class="preview-tab-icon selected">
                    <el-image :src="item.icon_selected_url" fit="contain" v-if="item.icon_selected_url" />
                  </div>
                  <div class="preview-tab-label active">{{ item.text }}</div>
                </div>
              </div>
              <div class="tabbar-row">
                <div v-for="item in tabbar" :key="item.id" class="preview-tab-item">
                  <div class="preview-tab-icon">
                    <el-image :src="item.icon_unselected_url" fit="contain" v-if="item.icon_unselected_url" />
                  </div>
                  <div class="preview-tab-label">{{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图标编辑对话框 -->
    <el-dialog v-model="iconDialogVisible" title="编辑图标" width="500px">
      <el-form ref="iconFormRef" :model="iconForm" :rules="iconRules" label-width="100px">
        <el-form-item label="标题" prop="title"><el-input v-model="iconForm.title" /></el-form-item>
        <el-form-item label="图标" prop="icon_url"><Upload v-model="iconForm.icon_url" :max-count="1" :width="80" :height="80" fit="contain" tip="推荐尺寸 宽 52 × 高 52 px" /></el-form-item>
        <el-form-item label="跳转路径"><el-input v-model="iconForm.path" placeholder="/pages/..." /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="iconForm.sort_order" :min="0" /></el-form-item>
        <el-form-item label="状态"><el-switch v-model="iconForm.status" /></el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="iconDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="iconSaving" @click="saveIcon">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';

const activeTab = ref('icons');

// 金刚区
const icons = ref([]);
const iconLoading = ref(false);
const iconDialogVisible = ref(false);

const iconSaving = ref(false);
const iconFormRef = ref(null);
const iconForm = ref({ id: null, title: '', icon_url: '', path: '', sort_order: 0, status: true });
const iconRules = { title: [{ required: true, message: '请输入标题' }], icon_url: [{ required: true, message: '请上传图标' }] };

const visibleIcons = computed(() => icons.value.filter(i => i.status !== false).slice(0, 10));

const fetchIcons = async () => {
  iconLoading.value = true;
  try { const r = await contentApi.getHomeIcons(); icons.value = (r.data || []).sort((a, b) => a.sort_order - b.sort_order); }
  catch {} finally { iconLoading.value = false; }
};
const updateIconSort = async (row) => { try { await contentApi.updateHomeIcon(row.id, { sort_order: row.sort_order }); await fetchIcons(); } catch {} };
const updateIconStatus = async (row) => { try { await contentApi.updateHomeIcon(row.id, { status: row.status }); } catch {} };
const showIconDialog = (row) => {
  iconForm.value = { ...row };
  iconDialogVisible.value = true;
};
const saveIcon = async () => {
  const ok = await iconFormRef.value.validate().catch(() => false);
  if (!ok) return;
  iconSaving.value = true;
  try {
    await contentApi.updateHomeIcon(iconForm.value.id, iconForm.value);
    ElMessage.success('成功');
    iconDialogVisible.value = false;
    await fetchIcons();
  } catch { ElMessage.error('保存失败'); } finally { iconSaving.value = false; }
};
// TabBar
const tabbar = ref([]);
const tabbarSaving = ref(false);
const fetchTabbar = async () => {
  try { const r = await contentApi.getTabBarConfigs(); tabbar.value = (r.data || []).sort((a, b) => a.sort_order - b.sort_order); }
  catch {}
};
const saveTabbar = async () => {
  tabbarSaving.value = true;
  try {
    for (const item of tabbar.value) await contentApi.updateTabBarConfig(item.id, { text: item.text, icon_selected_url: item.icon_selected_url, icon_unselected_url: item.icon_unselected_url });
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); } finally { tabbarSaving.value = false; }
};

// 宠物选择器
const pets = ref([]);
const petsSaving = ref(false);
const fetchPets = async () => {
  try { const r = await contentApi.getPetSelectors(); pets.value = (r.data || []).sort((a, b) => a.sort_order - b.sort_order); }
  catch {}
};
const savePets = async () => {
  petsSaving.value = true;
  try {
    for (const item of pets.value) await contentApi.updatePetSelector(item.id, { icon_url: item.icon_url, page_path: item.page_path });
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); } finally { petsSaving.value = false; }
};

onMounted(() => { fetchIcons(); fetchTabbar(); fetchPets(); });
</script>

<style scoped>
.page-wrap { height: 100%; display: flex; flex-direction: column; }
.home-deco-layout { display: flex; gap: 12px; flex: 1; min-height: 0; }
.left-panel { flex: 1; display: flex; flex-direction: column; min-width: 0; max-width: 580px; overflow-x: hidden; overflow-y: auto; }
.tabs-header { display: flex; flex-direction: column; flex: 1; min-height: 0; gap: 0; }
.tabs-header :deep(.el-tabs) { flex: 1; display: flex; flex-direction: column; min-height: 0; }
.tabs-header :deep(.el-tabs__content) { flex: 1; overflow-y: auto; padding-bottom: 4px; }
.tabs-actions { flex-shrink: 0; padding-top: 6px; }
.tab-toolbar { margin-bottom: 8px; }

.right-panel { width: 380px; flex-shrink: 0; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; padding-left: 0; padding-top: 10px; }
.phone-wrapper { position: sticky; top: 10px; }
.preview-hint { font-size: 12px; color: #e67e22; font-weight: 600; margin-bottom: 8px; text-align: center; line-height: 1.5; }
.phone-content { background: #faf8f5; border-radius: 16px; overflow: hidden; margin: 0; display: flex; flex-direction: column; }

.homepage-preview { }
.preview-navbar { display: flex; justify-content: center; align-items: center; height: 36px; background: #fff; position: relative; }
.nav-title { color: #333; font-size: 13px; font-weight: 700; }
.nav-icons { position: absolute; right: 10px; display: flex; gap: 12px; }
.nav-icon { color: #666; font-size: 13px; }

/* 轮播图 */
.preview-banner { position: relative; height: 120px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; }
.placeholder-content { font-size: 13px; color: #888; letter-spacing: 1px; }
.banner-dots { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); display: flex; gap: 5px; }
.banner-dots .dot { width: 5px; height: 5px; border-radius: 50%; background: rgba(255,255,255,0.5); }
.banner-dots .dot.active { width: 14px; border-radius: 3px; background: #fff; }

/* 会员权益 */
.preview-vip-placeholder { height: 44px; margin: -20px 14px 10px; background: linear-gradient(135deg, #f6d365 0%, #fda085 100%); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #7a3b00; font-weight: 600; letter-spacing: 0.5px; box-shadow: 0 2px 8px rgba(253, 160, 133, 0.4); position: relative; z-index: 1; }

/* 宠物选择器 */
.preview-pet-selector { display: flex; justify-content: center; gap: 36px; padding: 8px; background: #fff; border-radius: 10px; margin: 0 10px 8px; }
.preview-pet-item { display: flex; flex-direction: column; align-items: center; gap: 3px; font-size: 10px; color: #333; }
.preview-pet-img { width: 28px; height: 28px; border-radius: 50%; overflow: hidden; }
.preview-pet-img .el-image { width: 28px; height: 28px; }

/* 金刚区 */
.preview-icons { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px; padding: 8px 6px; background: #fff; border-radius: 10px; margin: 0 10px 8px; }
.preview-icon-item { display: flex; flex-direction: column; align-items: center; padding: 4px; }
.preview-icon-img { width: 28px; height: 28px; border-radius: 50%; background: #f5f0e6; display: flex; align-items: center; justify-content: center; overflow: hidden; font-weight: 600; color: #8b5e3c; font-size: 11px; }
.preview-icon-img .el-image { width: 28px; height: 28px; }
.preview-icon-label { font-size: 9px; color: #333; margin-top: 3px; text-align: center; line-height: 1.1; }

/* TabBar — 双排展示 */
.preview-tabbar { padding: 6px 0 2px; background: #fff; border-top: 1px solid #eee; }
.tabbar-label { text-align: center; font-size: 8px; color: #bbb; margin-bottom: 2px; }
.tabbar-row { display: flex; }
.preview-tab-item { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 2px 0; }
.preview-tab-icon { width: 16px; height: 16px; }
.preview-tab-icon .el-image { width: 16px; height: 16px; }
.preview-tab-label { font-size: 8px; color: #999; }
.tabbar-row:first-child .preview-tab-label { color: #8b5e3c; font-weight: 600; }

.config-card { border: 1px solid #e0e0e0; border-radius: 8px; padding: 10px 14px; margin-bottom: 8px; background: #fff; max-width: 540px; }
.config-card-title { font-size: 13px; font-weight: 600; margin-bottom: 6px; color: #333; }
.config-card-fields { display: flex; gap: 10px; align-items: flex-start; }
.field-group { display: flex; flex-direction: column; align-items: center; gap: 4px; }
.field-label { font-size: 12px; color: #999; }
</style>
